module.exports = "/images/cert_pro.bbb45.png";